import { useEffect, useState } from "react";
export const MODAL_LG = "modal-lg";
export const MODAL_XL = "modal-xl";
export const MODAL_SM = "modal-sm";
export const MODAL_md = "modal-md";

type ModalStyles = {
    headerClass?: string;
    bodyClass?: string;
    footerClass?: string;
    buttonClass?: string;
}

function useModal(title: string, size: string, styles?: ModalStyles) {

    const [submitLabel, setSumbmitLabel] = useState<string>('');
    const [modal, setModal] = useState<any>({ name: title, tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: size, styles: styles ?? {} });

    useEffect(() => {
        setModal(prev => ({
            ...prev,
            name: title,
            format: size,
        }));
    }, [title, size]);

    const open = (newName?: string, newSize?: string) => {
        setModal(prev => ({
            ...prev,
            view: true,
            name: newName ?? prev.name,
            format: newSize ?? prev.format
        }));
    };

    const close = () => {
        setModal(prev => ({
            ...prev,
            view: false
        }));
    };

    const setTitle = (title: string) => {
        setModal(prev => ({
            ...prev,
            name: title
        }));
    };

    return {
        modal,
        submitLabel,
        setSumbmitLabel,
        setModal,
        open,
        close,
        setTitle
    }


}
export default useModal;
